/*
 *		Copyright (c) 2011-2015 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */
'use strict';

angular.module('accessWebClient')
    .directive('accPreventBackspace', [function () {
        return function($scope, $element){
            $element.on('keydown', function($event){
                if ($event.keyCode === 8) {
                    $event.preventDefault();
                }
            });
        };
    }]);